// WP-1.20 (S-03/S-44 Security): active session list + revoke, over the WP-0.6 auth API.
import { sessionListResponseSchema, type SessionListResponse } from '@pfos/shared';
import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import { api } from './api';

export const SESSIONS_KEY = ['sessions'] as const;

export function useSessions(): UseQueryResult<SessionListResponse['sessions']> {
  return useQuery({
    queryKey: SESSIONS_KEY,
    queryFn: async () =>
      sessionListResponseSchema.parse(await api.get('/api/v1/auth/sessions')).sessions,
  });
}

export function useRevokeSession(): UseMutationResult<void, Error, string> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await api.post(`/api/v1/auth/sessions/${id}/revoke`);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: SESSIONS_KEY });
    },
  });
}
